import iconUrl from 'img/icon-report-2.png';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from 'services/redux-store';

import classes from './inspection-report-link.module.scss';

interface IInspectionReportLink {
    linkUrl: string | undefined;
    svvUnitId: number;
    variant?: 'xs' | 'small' | 'medium' | 'large';
    text?: string;
}

const InspectionReportLink: React.FC<IInspectionReportLink> = ({ linkUrl: inspectionReportUrl, svvUnitId, text, variant = 'medium' }) => {
    if (!inspectionReportUrl) {
        return null;
    }

    const apiUrl = process.env.REACT_APP_SIMULCAST_API || 'https://localhost:44339';

    const { account: { permissions: { viewHtmlInspectionReports = false } = {} } = {} } = useSelector((state: AppState) => state);

    const linkUrl = viewHtmlInspectionReports ? `${apiUrl}/api/inspection-viewer/${svvUnitId}` : inspectionReportUrl;

    return (
        /*   GTM: inspection-report-trigger class required for GA. */
        <a
            href={linkUrl}
            title={'View Inspection Report'}
            target="_blank"
            rel="noopener noreferrer"
            className={`${classes['inspection-link']} ${classes['icon-text']} ${classes[variant]} inspection-report-trigger`}>
            <img src={iconUrl} />
            {text && (<span>{text}</span>)}
        </a>
    );
};

export default InspectionReportLink;
